// extracted by mini-css-extract-plugin
export default {"small":"NavButton_small__qDBRP","standard":"NavButton_standard__JE3GD","adapt":"NavButton_adapt__0Sydj","nav_button":"NavButton_nav_button__dLWYT"};